import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ApplicationDto, SingleApplicationDto } from '@dto';
import { GenericOldService } from './generic-old.service';
const APPLICATIONS_ENDPOINT = 'applications';

@Injectable()
export class ApplicationService {
  private applications$: Observable<SingleApplicationDto[]>;
  private _applications: SingleApplicationDto[];
  private _appsList: BehaviorSubject<SingleApplicationDto[]> = new BehaviorSubject<SingleApplicationDto[]>([]);

  get applications(): SingleApplicationDto[] {
    return this._applications;
  }

  get appsList(): BehaviorSubject<SingleApplicationDto[]> {
    return this._appsList;
  }

  constructor(private resourceService: GenericOldService<ApplicationDto>) {}

  getApplications(): Observable<SingleApplicationDto[]> {
    if (!this.applications$ && !this._applications) {
      this.applications$ = this.resourceService.get(APPLICATIONS_ENDPOINT).pipe(
        map(apps => {
          // if we are locally developing, set the admin URL to local
          if (
            window.location.hostname === 'local.dev.apps.calibrantenergy.net' &&
            apps &&
            Object.keys(apps)?.length > 0
          ) {
            Object.keys(apps).map(appKey => {
              if (apps[appKey].id === 'USER_ADMIN') {
                apps[appKey].url = 'http://local.dev.apps.calibrantenergy.net:9000/admin';
              }
            });
          }
          this._applications = Object.values(apps);
          this._appsList.next(this._applications);
          return this._applications;
        }),
        shareReplay(1),
      );
    }
    return this.applications$;
  }
}
